import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

import * as Styles from '../Icon.module.scss';

const copyWithoutBackgroundTestID = 'copy-without-background-test-id';

export const CopyWithoutBackground = ({ size = 'medium', fill = 'black' }: IconProps) => {
    const iconSize = IconSizes[size];
    const fillStyle = cn(Styles[fill], Styles.fill);

    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 18 22"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={copyWithoutBackgroundTestID}
        >
            <path
                className={fillStyle}
                id="azu4f4s64a"
                d="M1,21H12V6H1v15ZM12,5c.55,0,1,.45,1,1v15c0,.55-.45,1-1,1H1c-.55,0-1-.45-1-1V6c0-.55,.45-1,1-1H12ZM17,0c.55,0,1,.45,1,1v15c0,.55-.45,1-1,1h-2v-1h2V1H6v3h-1V1c0-.55,.45-1,1-1h11Z"
            />
        </svg>
    );
};

CopyWithoutBackground.TEST_ID = copyWithoutBackgroundTestID;
